module.exports = __webpack_public_path__ + "media/images/preview_training_2-67497e8750265fa6e5cae5ef64bcc8d9.webp";